<template>
  <div class="buyer">
    <el-container>
      <el-header>
        <div class="topNavBar">
          <div class="logo">
            <img src="../../assets/imgs/MES-LOGO.png" alt />
          </div>
          <i
            class="el-icon-s-operation colaspseBtn"
            :class="{rotate:isCollapse}"
            @click="isCollapse=!isCollapse"
          ></i> 
          <el-button type="success" @click="$router.push('/Cpdf')" class="course">使用说明</el-button>
          <el-button type="primary" @click="logout">退出</el-button>
        </div>
      </el-header>
      <div class="mainNavigation" >
        <el-container >
          <el-aside width="auto" class="asideMain">
            <el-menu
              :default-active="currentMenu" 
              class="el-menu-vertical-demo"
              :collapse="isCollapse"
              background-color="#545c64"
              text-color="#fff"
              active-text-color="#ffd04b"
              router
            >
              <!--用户信息管理 -->
              <el-menu-item index="/userInfo"  v-show="showUserInfo">
                <i class="el-icon-user-solid"></i>
                <span slot="title">用户信息管理</span>
              </el-menu-item>
              <!-- listing管理 -->
               <el-menu-item index="/listing"  v-show="showListing">
                <i class="el-icon-menu"></i>
                <span slot="title">Listing管理</span>
              </el-menu-item>
              <!-- 客诉管理 -->
              <el-menu-item index="/client" >
                <i class="el-icon-phone"></i>
                <span slot="title">客诉管理</span>
              </el-menu-item>
              <!-- 评论管理 -->
              <el-menu-item index="/comments">
                <i class="el-icon-s-comment"></i>
                <span slot="title">评论管理</span>
              </el-menu-item>
              <!-- 用户自助登记管理 -->
              <el-menu-item index="/AutoLogin" >
                <i class="el-icon-s-marketing"></i>
                <span slot="title">售后登记表-卖家</span>
              </el-menu-item>
              <!-- 礼品表 -->
              <el-menu-item index="/home/freeGift" >
                <i class="el-icon-present"></i>
                <span slot="title">礼品表</span>
              </el-menu-item>
              <!-- 礼品表 -->
              <el-menu-item index="/home/autoLoginFreeGift" >
                <i class="el-icon-s-marketing"></i>
                <span slot="title">客户需求表-买家</span>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-main>
            <router-view></router-view>
<!--           <div class="footer"> Copyright © csvip.club<img src="../../assets/imgs/beian.png" alt=""> <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2020126125号</a></div>-->
          </el-main>
        </el-container>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCollapse: false,
      showUserInfo: true,
      showListing: true,
      role:'',//存储角色
      currentMenu:'/AutoLogin',
      courseDialogVisible:false,//弹框
    };
  },
  methods: {
    showModuleFunction(){
     this.role = JSON.parse(window.localStorage.getItem('role'))
     if(this.role == 'Support'){
       this.showUserInfo = false;
      this.showListing = false
     }else if(this.role == 'Seller'){
       this.showUserInfo = false;
     }
    },
    getUrl(){
      let self = this;
      let currentUrl = window.location.href;
      self.currentMenu = currentUrl.split('#')[1];
    },
      // 退出
    logout() {
      this.$confirm('确定退出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('Authorization')
          this.$router.push('/login')
        }).catch(() => {
          // 取消了         
        })
    }
  },
  created(){
    this.showModuleFunction();
    this.getUrl()
  }  

};
</script>

<style lang='less' scoped>
.buyer {
  min-width: 1366px;
  background-color: #e4e5e6;
  height: 100%;
  .topNavBar {
    height: 55px;
    min-width: 1366px;
    background-color: #fff;
    border-bottom: 1px solid #c8ced3;
    margin: 0 auto;
    overflow: hidden;
    position: relative;

    .logo {
      width: 162px;
      height: 40px;
      margin-top: 0px;
      float: left;
      img {
        width: 100%;
      }
    }
    .el-menu {
      float: left;
    }
    .footbar {
      float: right;
    }

    .el-icon-s-operation.colaspseBtn {
      float: left;
      font-size: 28px;
      margin: 15px;
    }
    .personList {
      float: right;
      i {
        font-size: 25px;
        color: #333;
        margin: 15px;
        cursor: pointer;
      }
    }
  }
}
.asideMain{
  min-height:calc(100vh) ;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  height: 100%;
}
.el-menu--collapse {
  width: 64px;
  height: 100%;
}
.el-menu-item i {
  color: #fff;
}
.el-submenu__title i {
  color: #fff;
}
.el-header {
  height: 55px !important;
  padding: 0px;
}
.el-main {
  padding: 0px;
}
.el-button{
  float: right;
  margin-top: 8px;
  margin-right: 10px;
}
.course{
  float: left;
  margin-left:30px;
}
.footer{
    text-align: center;
    // background-color: rgb(84, 92, 100);
    color: 	#0A0A0A;
    height: 50px;
    line-height: 50px;
    img{
      margin: 0px 6px;
    }
    a{
       color: #337ab7;
    }
}
</style>